import { useState } from 'react';

const API = process.env.REACT_APP_API_URL || '';

export default function SubmitQuestionsView({ event: ev, user, onCancel, onSubmitted }) {
  const [questions, setQuestions] = useState([]);
  const [newQuestion, setNewQuestion] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editingText, setEditingText] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleAdd = () => {
    const text = newQuestion.trim();
    if (!text) return;
    setQuestions((prev) => [...prev, { id: Date.now(), text }]);
    setNewQuestion('');
  };

  const startEdit = (q) => {
    setEditingId(q.id);
    setEditingText(q.text);
  };

  const saveEdit = () => {
    if (editingId == null) return;
    const text = editingText.trim();
    setQuestions((prev) =>
      text
        ? prev.map((q) => (q.id === editingId ? { ...q, text } : q))
        : prev.filter((q) => q.id !== editingId)
    );
    setEditingId(null);
    setEditingText('');
  };

  const removeQuestion = (id) => {
    setQuestions((prev) => prev.filter((q) => q.id !== id));
    if (editingId === id) {
      setEditingId(null);
      setEditingText('');
    }
  };

  const handleSubmit = () => {
    const list = questions.map((q) => q.text).filter(Boolean);
    if (list.length === 0) return;
    setError(null);
    setSubmitting(true);
    fetch(`${API}/api/events/${ev.id}/questions`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        questions: list,
        author: user?.displayName || user?.username || '',
      }),
    })
      .then((res) => {
        if (!res.ok) return res.json().then((err) => { throw new Error(err.error || 'Failed to submit'); });
        return res.json();
      })
      .then(() => {
        setSubmitting(false);
        if (typeof onSubmitted === 'function') onSubmitted();
      })
      .catch((err) => {
        setError(err.message || 'Failed to submit');
        setSubmitting(false);
      });
  };

  if (!ev) return null;

  return (
    <div className="SubmitQuestions-view App-block">
      <h2>Submit questions — {ev.title}</h2>
      <p className="SubmitQuestions-intro">Add your questions below. You can edit them before submitting.</p>

      <div className="SubmitQuestions-add">
        <input
          type="text"
          value={newQuestion}
          onChange={(e) => setNewQuestion(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), handleAdd())}
          placeholder="Kysy tapahtumajärjestäjältä..."
          className="SubmitQuestions-input"
        />
        <button type="button" className="Button SubmitQuestions-add-btn" onClick={handleAdd}>
          +
        </button>
      </div>

      <h2>Your questions</h2>
      <ul className="SubmitQuestions-list">
        {questions.map((q) => (
          <li key={q.id} className="SubmitQuestions-item">
            {editingId === q.id ? (
              <>
                <input
                  type="text"
                  value={editingText}
                  onChange={(e) => setEditingText(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') saveEdit();
                    if (e.key === 'Escape') setEditingId(null) || setEditingText('');
                  }}
                  className="SubmitQuestions-input SubmitQuestions-edit-input"
                  autoFocus
                />
                <button type="button" className="Button SubmitQuestions-save-edit" onClick={saveEdit}>
                  Save
                </button>
              </>
            ) : (
              <>
                <span className="SubmitQuestions-item-text">{q.text}</span>
                <div className="SubmitQuestions-item-actions">
                  <button type="button" className="Button SubmitQuestions-edit-btn" onClick={() => startEdit(q)}>
                    E
                  </button>
                  <button type="button" className="Button SubmitQuestions-remove-btn" onClick={() => removeQuestion(q.id)}>
                    X
                  </button>
                </div>
              </>
            )}
          </li>
        ))}
      </ul>

      {error && <p className="SubmitQuestions-error">{error}</p>}

      <div className="SubmitQuestions-actions">
        <button type="button" className="Button SubmitQuestions-cancel" onClick={onCancel}>
          Cancel
        </button>
        <button
          type="button"
          className="Button SubmitQuestions-submit"
          onClick={handleSubmit}
          disabled={questions.length === 0 || submitting}
        >
          {submitting ? 'Submitting…' : 'Submit'}
        </button>
      </div>
    </div>
  );
}
